export default __webpack_public_path__ + "static/media/SetPasswordPhn.9fc7f783.svg";